import { DocumentRecord, DocumentRecordData } from '../../offline-first';

export class WorkoutSessionDocument extends DocumentRecord<WorkoutSession> {
  static recordName = 'WorkoutSessionDocument';
  static objectStoreName = 'workoutSessionDocuments';

  constructor(data?: DocumentRecordData<WorkoutSession>) {
    super(data);
  }
}

export interface WorkoutSession {
  key: string;
  exercise_program_id: string;

  start_time: string;
  end_time?: string;
  completion_time_ms?: number; // in milliseconds
  complete?: boolean;

  group?: Group;
  leaders: User[];
  attendees: User[];

  plan: Plan;
  workout: Workout;

  // computed on front-end
  total_tiers: number;
  completed_tiers: number;
  total_exercises: number;
  completed_exercises: number;

  // computed on back-end
  attendance_count?: number;

  phase?: { uuid: string, name: string };
}

interface Plan {
  version?: number;
  id: string;
  name: string;
  num_weeks: number;
  start_date: string;
  creator: User;
  notes?: string;
}

interface Workout {
  id: string;
  name: string;
  workout_type_id?: string;
  tiers: Tier[];
}

interface Tier {
  id: string;
  name: string;
  notes?: string;
  order: number;
  rows: Row[];
  complete?: boolean;
}

interface Row {
  exercise: Exercise;
  order: number;
  parameters: object;
  notes?: string;
  executions: Execution[];
  start_time: string;
  end_time: string;
  complete?: boolean;
  comments?: string;
}

interface Exercise {
  exercise_program_id: string;
  name: string;
  exercise_categories: string[];
}

interface Execution {
  parameter_values: object;
  rest_time?: string;
  complete_time?: string;
}

interface Group {
  uuid: string;
  name: string;
  group_size: number;
}

interface User {
  uuid: string;
  email: string;
  first_name: string;
  last_name: string;
}
